import { configureStore } from '@reduxjs/toolkit'
import bingoReducer from './bingoReducer'

export const store = configureStore({
  reducer: {
    bingo: bingoReducer
  },
})

